import React from 'react';
import {
    Box,
    Grid,
    Typography,
    CardMedia,
    Stack
} from '@mui/material';

import img1 from '../assets/1.jpg';
import img2 from '../assets/2.jpg';
import img5 from '../assets/3.jpg';
import img4 from '../assets/4.jpg';
import img3 from '../assets/5.jpg';
import img6 from '../assets/6.jpg';
import img7 from '../assets/7.jpg';

const services = [
    { title: 'Cobble Stone', image: img1 },
    { title: 'Paving Stone', image: img2 },
    { title: 'Granite Slabs', image: img3 },
    { title: 'Wall Cladding', image: img4 },
    { title: 'Landscape', image: img5 },
    { title: 'Monuments', image: img6 },
    { title: 'Garden Stone', image: img7 },
];

const Services = () => {
    return (
        <Box
            sx={{
                py: 10,
                bgcolor: 'white',
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            {/* 1200px wrapper */}
            <Box sx={{ width: '100%', maxWidth: '1200px' }}>
                {/* Header - with padding only on sides */}
                <Box sx={{ textAlign: 'center', mb: 6, px: 2 }}>
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        spacing={1}
                        sx={{ mb: 1 }}
                    >
                        <Box
                            sx={{
                                width: 15,
                                height: 15,
                                bgcolor: '#5c9bd8',
                                border: '5px solid #d3dee4',
                                borderRadius: '50%',
                            }}
                        />
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                fontSize: '0.875rem',
                            }}
                        >
                            What We Do?
                        </Typography>
                    </Stack>

                    <Typography variant="h3" sx={{ fontWeight: 700 }}>
                        Services
                    </Typography>

                    <Box
                        sx={{
                            width: 60,
                            height: 4,
                            bgcolor: 'primary.main',
                            mx: 'auto',
                            mt: 2,
                        }}
                    />
                </Box>

                {/* Grid - with overflow handling */}
                <Box sx={{ overflow: 'hidden', px: 2 }}>
                    <Grid container spacing={4}>
                        {services.map((service, index) => (
                            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                                <Box
                                    sx={{
                                        position: 'relative',
                                        overflow: 'hidden',
                                        cursor: 'pointer',
                                        height: 350,
                                        borderRadius: 2,
                                        '&:hover img': {
                                            transform: 'scale(1.1)',
                                        },
                                        '&:hover .overlay': {
                                            opacity: 1,
                                        },
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        image={service.image} about=''
                                        alt={service.title}
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            transition: 'transform 0.5s ease',
                                        }}
                                    />

                                    <Box
                                        className="overlay"
                                        sx={{
                                            position: 'absolute',
                                            bottom: 0,
                                            left: 0,
                                            right: 0,
                                            bgcolor: 'rgba(0,0,0,0.7)',
                                            color: 'white',
                                            textAlign: 'center',
                                            py: 2,
                                            opacity: 0,
                                            transition: 'opacity 0.3s ease',
                                        }}
                                    >
                                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                            {service.title}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
};

export default Services;